import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  Box,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { formatDateAndTimeUTC } from "../../utils/genericMethod";

const interviewSchema = z.object({
  interviewDate: z.union([z.date(), z.literal(null)]).refine(date => {
    if (date === null) return false; // If null, return false for the "required" message
    return !isNaN(date.getTime()); // Validate if the date is not invalid
  }, {
    message: "Interview Date is required",
  }),
  interviewTime: z.union([z.date(), z.literal(null)]).refine((time) => {
    if (time === null) return false;
    return !isNaN(time.getTime()); // ✅ valid JS Date check
  }, {
    message: "Interview Time is required and must be valid",
  }),

});

export function useInterviewForm(onSubmit, interviewDateTime = null) {
  // Don't pre-populate form with existing time
  // Users should select a new time
  const form = useForm({
    resolver: zodResolver(interviewSchema),
    defaultValues: {
      interviewDate: null,
      interviewTime: null,
    },
  });

  const handleSubmit = form.handleSubmit((data) => {
    onSubmit(data);
  });

  return { form, handleSubmit };
}

export function ScheduleInterview({ open, onClose, onSubmit, interviewDateTime = null }) {
  // interviewDateTime has date & time , and i want if it has value then by defult set 

  const { form, handleSubmit } = useInterviewForm(onSubmit, interviewDateTime);
  const { setValue, watch, formState: { errors } } = form;

  // Get today's date and the max date (3 months from today)
  const today = dayjs();
  const maxDate = today.add(3, "month");


  const handleDialogClose = (event, reason) => {
    // Prevent closing on backdrop click or pressing the Escape key
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose();
  };

  console.log("errors", errors)
  return (
    <Dialog open={open} onClose={handleDialogClose} // Update the onClose handler
      disableEscapeKeyDown>
      <DialogTitle>Schedule Interview</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, }}>
        <Divider />
        {interviewDateTime && (
          <Box sx={{ p: 1.5, bgcolor: '#e3f2fd', border: '1px solid #2196f3', borderRadius: 1 }}>
            <Typography variant="body2" color="primary" sx={{ fontWeight: 'bold', mb: 0.5 }}>
              📅 Current Interview Scheduled (Backend UTC):
            </Typography>
            <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold' }}>
              {formatDateAndTimeUTC(interviewDateTime)}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
              Select new date/time below to reschedule
            </Typography>
          </Box>
        )}
        <LocalizationProvider dateAdapter={AdapterDayjs} fullWidth>
          <DatePicker
            label="Interview Date"
            value={watch("interviewDate") ? dayjs(watch("interviewDate")) : null}
            onChange={(date) => {
              if (date?.isValid()) {
                setValue("interviewDate", date.toDate());
                const currentTime = watch("interviewTime");
                let newDate = date.toDate();

                if (currentTime) {
                  const time = dayjs(currentTime);
                  // Set hours/minutes/seconds from existing time
                  newDate.setHours(time.hour());
                  newDate.setMinutes(time.minute());
                  newDate.setSeconds(0);
                  newDate.setMilliseconds(0);
                  setValue("interviewTime", newDate); // update time to match new date
                }

                // setValue("interviewDate", newDate); // update date
              }
            }}
            minDate={today}
            maxDate={maxDate}
            slotProps={{
              textField: {
                error: !!errors.interviewDate,
                helperText: errors.interviewDate?.message,
              },
            }}
          />

          <DemoContainer fullWidth components={['TimePicker']}>
            <TimePicker
              label="Interview Time"
              value={watch("interviewTime") ? dayjs(watch("interviewTime")) : null}
              onChange={(time) => {
                const currentDate = watch("interviewDate");
                if (time?.isValid()) {
                  let newTime = time.toDate();
                  if (currentDate) {
                    // Combine current date with selected time
                    newTime.setFullYear(currentDate.getFullYear());
                    newTime.setMonth(currentDate.getMonth());
                    newTime.setDate(currentDate.getDate());
                  }
                  setValue("interviewTime", newTime);
                }
              }}
              slotProps={{
                textField: {
                  error: !!errors.interviewTime,
                  helperText: errors.interviewTime?.message,
                },
              }}
            />
          </DemoContainer>

          {/* <DatePicker
            label="Interview Date"
            value={watch("interviewDate") ? dayjs(watch("interviewDate")) : null}
            onChange={(date) => {
              if (date?.isValid()) {
                setValue("interviewDate", date.toDate());
              }
            }}
            minDate={today}
            maxDate={maxDate}
            slotProps={{
              textField: {
                error: !!errors.interviewDate,
                helperText: errors.interviewDate?.message,
              },
            }}
          />


          <DemoContainer fullWidth components={['TimePicker']}>
            <TimePicker
              label="Interview Time"
              value={watch("interviewTime") ? dayjs(watch("interviewTime")) : null}
              onChange={(time) => {
                if (time?.isValid()) {
                  setValue("interviewTime", time.toDate());
                }
              }}
              slotProps={{
                textField: {
                  error: !!errors.interviewTime,
                  helperText: errors.interviewTime?.message,
                },
              }}
            />
          </DemoContainer> */}


        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained">Schedule</Button>
      </DialogActions>
    </Dialog>
  );
}


